import styled from 'styled-components';

export const StyledCopyright = styled.span`
  display: block;
  font-size: 18px;
  line-height: 27px;
  color: #333333;
`;
